import { DateTime } from 'luxon';
import { Model } from 'pinia-orm';
import { BelongsTo, HasMany, Num, Str } from 'pinia-orm/dist/decorators';
import Package from './Package';
import PackageTenderItem from './PackageTenderItem';
import Supplier from './Supplier';

export const PackageTenderStatus = {
  draft: 'draft',
  issued: 'issued',
  submitted: 'submitted',
} as const;

export const PackageTenderStatusTitles = {
  draft: 'Draft',
  issued: 'Issued',
  submitted: 'Submitted',
} as const;

export const PackageTenderStatusBadgeClasses = {
  draft: 'bg-gray-100 text-gray-800',
  issued: 'bg-blue-100 text-blue-800',
  submitted: 'bg-green-100 text-green-800',
} as const;

export default class PackageTender extends Model {
  static entity = 'App\\Models\\PackageTender';

  @Num(0)
  declare id: number;
  @Num(0)
  declare package_id: number;
  @Num(0)
  declare supplier_id: number;
  @Str('draft')
  declare status: string;
  @Num(1)
  declare price_revision: number;
  @Str(undefined)
  declare issued_at: string | undefined;
  @Str(undefined)
  declare issued_at_time_zone: string | undefined;
  @Str(undefined)
  declare submitted_at: string | undefined;
  @Str(undefined)
  declare submitted_at_time_zone: string | undefined;
  @Str('')
  declare created_at: string;
  @Str('')
  declare updated_at: string;

  @BelongsTo(() => Package, 'package_id', 'id')
  declare package: Package;
  @BelongsTo(() => Supplier, 'supplier_id', 'id')
  declare supplier: Supplier;
  @HasMany(() => PackageTenderItem, 'package_tender_id', 'id')
  declare items: PackageTenderItem[];

  get totalAmount(): number {
    return this.items?.reduce((total, item) => total + (item.amount ?? 0), 0) ?? 0;
  }

  get statusTitle(): string {
    return PackageTenderStatusTitles[this.status as keyof typeof PackageTenderStatusTitles] ?? this.status;
  }

  get statusBadgeClass(): string {
    return PackageTenderStatusBadgeClasses[this.status as keyof typeof PackageTenderStatusBadgeClasses] ??
      PackageTenderStatusBadgeClasses.draft;
  }

  get issuedAt() {
    return this.issued_at ?
      DateTime.fromISO(this.issued_at).setZone(this.issued_at_time_zone) :
      undefined;
  }

  get submittedAt() {
    return this.submitted_at ?
      DateTime.fromISO(this.submitted_at).setZone(this.submitted_at_time_zone) :
      undefined;
  }
}
